export interface IDatepickerDisabledDates {
	from?: Date;
	to?: Date;
}
